import { RepositoryFactory } from "@/Apicall/RepositoryFactory";
const course =  RepositoryFactory.get("course");
export default {
  createCourse({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
          const { data } = await course.createCourse(payload)

          commit("CREATE_COURSE", data.data);


        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  getAllCourse({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
          const { data } = await course.getAllCourse(payload)

          commit("GET_COURSE_DATA", data.data);


        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  getSingleCourse({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
          const { data } = await course.getSingleCourse(payload)

          commit("GET_SINGLE_COURSE", data.data);


        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  updateCourse({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
          const { data } = await course.updateCourse(payload)
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  deleteCourse({ }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
          const { data } = await course.deleteCourse(payload)

        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
};